// API Configuration
// Centralizes all API endpoints and URLs

const isDev = import.meta.env.DEV;

export const API_CONFIG = {
  // Base URLs from environment variables
  API_URL: isDev
    ? (import.meta.env.VITE_API_URL || 'http://localhost:8787/api')
    : (import.meta.env.VITE_PROD_API_URL || 'https://goalyet-api.b-9f2.workers.dev/api'),

  FILES_URL: isDev
    ? (import.meta.env.VITE_FILES_URL || 'http://localhost:8788')
    : (import.meta.env.VITE_PROD_FILES_URL || 'https://goalyet-files.b-9f2.workers.dev'),

  // API Endpoints
  endpoints: {
    // Auth
    login: '/login',
    verifyToken: '/verify-token',
    
    // Users
    users: '/users',
    
    // AI
    ai: {
      generate: '/ai/generate',
      analyzeUser: '/ai/analyze-user',
      models: '/ai/models'
    }
  }
};

// Helper to build full URLs
export const buildApiUrl = (endpoint: string): string => {
  return `${API_CONFIG.API_URL}${endpoint}`;
};

export const buildFilesUrl = (path: string): string => {
  return `${API_CONFIG.FILES_URL}${path}`;
};